/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metric } from './Metric';
import {
    MetricFromJSON,
    MetricFromJSONTyped,
    MetricToJSON,
    MetricToJSONTyped,
} from './Metric';

/**
 * 
 * @export
 * @interface BranchOrderTypesNetSalesResponse
 */
export interface BranchOrderTypesNetSalesResponse {
    /**
     * 
     * @type {Array<Metric>}
     * @memberof BranchOrderTypesNetSalesResponse
     */
    data: Array<Metric>;
}

/**
 * Check if a given object implements the BranchOrderTypesNetSalesResponse interface.
 */
export function instanceOfBranchOrderTypesNetSalesResponse(value: object): value is BranchOrderTypesNetSalesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BranchOrderTypesNetSalesResponseFromJSON(json: any): BranchOrderTypesNetSalesResponse {
    return BranchOrderTypesNetSalesResponseFromJSONTyped(json, false);
}

export function BranchOrderTypesNetSalesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchOrderTypesNetSalesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MetricFromJSON)),
    };
}

export function BranchOrderTypesNetSalesResponseToJSON(json: any): BranchOrderTypesNetSalesResponse {
    return BranchOrderTypesNetSalesResponseToJSONTyped(json, false);
}

export function BranchOrderTypesNetSalesResponseToJSONTyped(value?: BranchOrderTypesNetSalesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MetricToJSON)),
    };
}

